import { apiUrl } from '../config/api'

export async function insertCompliance(params) {
  params.brandLabel = window.$brand

  let url = apiUrl('InsertCompliance')

  return sendReq(params, url)
}

export async function listCompliances(userId) {
  let params = {
    userId: userId,
    brandLabel: window.$brand
  }

  let url = apiUrl('ListCompliances')

  return sendReq(params, url)
}

export async function deleteCompliance(id, loggedUserId) {
  let params = {
    id: id,
    loggedUserId: loggedUserId,
    brandLabel: window.$brand
  }

  let url = apiUrl('DeleteCompliance')
  return sendReq(params, url, true)
}

export async function updateCompliance(params) {
  params.brandLabel = window.$brand

  let url = apiUrl('UpdateCompliance')

  return sendReq(params, url)
}

async function sendReq(params, url, allowEmpty = false) {
  const res = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(params)
  }).catch((error) => console.log(error))

  if (!res) return null

  if (!res.ok) {
    console.warn(`Request failed: ${res.status}`)
    return { status: res.status }
  }

  const text = await res.text()
  return text ? JSON.parse(text) : { status: res.status }
}
